<ng-container *ngIf="(crudService.loader$ | async) else loader">
    <div class="spinner">
        <mat-spinner [strokeWidth]="5" [diameter]="40"></mat-spinner>
    </div>
</ng-container>
<ng-template #loader>
    <ng-content></ng-content>
</ng-template>